/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceStringTemplate = exports.isReactNative = exports.jssMerge = exports.cleanUrl = void 0;

exports.cleanUrl = function (url) {
  var components = url.split('//');
  return "".concat(components.shift(), "//").concat(components.join('/'));
};

exports.jssMerge = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args) {
    return Object.assign.apply(Object, [{}].concat(args));
  }

  return {};
};

exports.isReactNative = function () {
  return typeof document === 'undefined';
};

exports.replaceStringTemplate = function (template, templateMap) {
  Object.keys(templateMap).forEach(function (key) {
    if (template.indexOf(key) === -1) {
      template = template.replace(key, '');
      return;
    }

    if (!templateMap[key]) {
      console.warn("Missing value for ".concat(key, " in replaceStringTemplate"));
    }

    template = template.replace(key, templateMap[key]);
  });
  return template;
};